import { SET_LOADING, GET_LAST_ACTIVITY_REPORT } from './types'

const initialState = {
  lastActivityReportData: {
    query: {},
    data: [],
  },
  isLoading: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_LAST_ACTIVITY_REPORT:
      return {
        ...state,
        lastActivityReportData: action.payload,
        isLoading: false,
      }
    case SET_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    default:
      return state
  }
}
